import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Content } from 'ionic-angular';
import {
  BusquedaTesoroPreguntaPage,
  BusquedaTesoroNivelesPage,
  BusquedaTesoroCofrePage
} from '@pages';

@IonicPage()
@Component({
  selector: 'page-busqueda-tesoro-nivel-detalle',
  templateUrl: 'busqueda-tesoro-nivel-detalle.html',
})
export class BusquedaTesoroNivelDetallePage {

  @ViewChild(Content) private instrucciones: Content;
  nombreSede: string;
  preguntas: any;
  objetivo: any;
  busquedaDelTesoro: any;
  avanceID: string;
  nivel: any;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.nombreSede        = this.navParams.get('nombreSede');
    this.preguntas         = this.navParams.get('preguntas');
    this.objetivo          = this.navParams.get('objetivo');
    this.busquedaDelTesoro = this.navParams.get('busquedaDelTesoro');
    this.avanceID          = this.navParams.get('avanceID');
    this.nivel             = this.navParams.get('nivel');
  }

  ionViewDidLoad() {   }

  comenzar() {
    if(this.instrucciones) {
      this.instrucciones.scrollToBottom(500);
    }

    this.navCtrl.setRoot(BusquedaTesoroPreguntaPage,{
      busquedaDelTesoro: this.busquedaDelTesoro,
      preguntas: this.preguntas,
      avanceID: this.avanceID,
      nombreSede: this.nombreSede,
      objetivo: this.objetivo,
      nivel: this.nivel
    });
  }

  exit() {
    this.navCtrl.setRoot(BusquedaTesoroNivelesPage,{
      busquedaTesoro: this.busquedaDelTesoro
    });
  }

  verTesoro() {
    this.navCtrl.push(BusquedaTesoroCofrePage, {
      nivel: this.nivel
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/busqueda-tesoro-nivel-detalle/busqueda-tesoro-nivel-detalle.ts